import { createContext, useContext } from 'react';

export const OverlayContext = createContext<{ overlayContainer: HTMLDivElement | null }>({
  overlayContainer: null,
});

export function useOverlayContainer() {
  return useContext(OverlayContext).overlayContainer;
}
